import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Chip from "@mui/material/Chip";

import UserService from "services/UserService";
import { downloadFile } from "services/ConfigServices";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "00rem 0rem 0.6rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "#000000",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    // wordWrap: "break-word",
    "& .MuiInputBase-root": {
      height: "45px",
      //wordWrap: "break-word",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      //wordWrap: "break-word",
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
      //wordWrap: "break-word",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .MuiAutocomplete-tag": {
      fontSize: "12px",
      fontFamily: '"Source Sans Pro",sans-serif',
      height: "24px",
      //wordWrap: "break-word",
    },
    "& .Mui-disabled": {
      color: "#000000",
      opacity: "1",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
    },
  },
  chipstyledisabled: {
    "& .MuiChip-deleteIcon	": {
      display: "none",
    },
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
  },
  chipstyle: {
    fontSize: "12px",
    fontFamily: '"Source Sans Pro",sans-serif',
    height: "24px",
    cursor: "pointer",
    margin: "0 1px 2px",
  },
  chipdiv: {
    //borderRadius: "4px",
    //border: "1px solid #bdbdbd",
    height: "45px",
    paddingTop: "10px",
    //margin: "2px 8px",
  },
  nofilediv: {
    paddingLeft: "13px",
    color: "#000000",
    paddingTop: "1px",
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
}));

const downloadGED = (id, name) => async () => {
  console.log("download ged");
  axios
    .get(downloadFile(id), {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${UserService.getToken()}`,
      },
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

export default function AutocompleteMultiselectCheckbox(props) {
  const {
    inputTitle,
    selected,
    list,
    handleChange,
    specialWidth,
    isRequired,
    disabled,
  } = props;

  const classes = useStyles();

  return (
    <div className={classes.input}>
      {/* <text className={classes.inputTitle}>{inputTitle}</text> */}

      {disabled ? (
        <div className={classes.chipdiv}>
          {selected.length > 0 ? (
            selected.map((obj, index) => (
              <Chip
                className={classes.chipstyle}
                label={obj?.name}
                onClick={downloadGED(obj?.id, obj?.name)}
              />
            ))
          ) : (
            <div className={classes.nofilediv}>{inputTitle}</div>
          )}
        </div>
      ) : (
        <Autocomplete
          multiple
          disableCloseOnSelect
          style={{ width: specialWidth }}
          id="checkboxes-tags"
          value={selected}
          options={list}
          //  ChipProps={props.disabled ? {className:classes.chipstyledisabled} : {className:classes.chipstyle}}
          getOptionLabel={(option) => option?.name}
          getOptionSelected={(selected, list) => selected?.id === list?.id}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField
              {...params}
              required={isRequired}
              style={{ margin: "2px 8px" }}
              variant="outlined"
              label={inputTitle}
              placeholder={"Ajouter"}
              className={classes.textField}
            />
          )}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{
                  marginRight: 8,
                }}
                checked={selected}
              />
              {option?.name}
            </React.Fragment>
          )}
        />
      )}
    </div>
  );
}

AutocompleteMultiselectCheckbox.defaultProps = {
  specialWidth: "99%",
  isRequired: false,
  isMultiple: true,
};

AutocompleteMultiselectCheckbox.propTypes = {
  isMultiple: PropTypes.bool,
  isRequired: PropTypes.bool,
  specialWidth: PropTypes.string,
  inputTitle: PropTypes.any,
  dateInput: PropTypes.any,
  handleDateInputChange: PropTypes.any,
};
